module.exports = __webpack_public_path__ + "static/media/DSC03553.4734957f.JPG";